import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import ContentWrapper from "../ContentWrapper";
import Block from "../Block";
import Column from "../Column";
import Img from 'gatsby-image';
import markdown from "../../lib/remark";

const propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    map: PropTypes.object
};

const defaultProps = {
    className: undefined
};

function stripScheme(url) {
    return url.replace(/https?:\/\//, '');
}

export default function DistributionLocation({ className, title, map, distributor }) {
    const titleClasses = classnames({
        "text-2xl  text-cobalt  font-normal  block": true
    });
    const item = classnames({
        "mb-8": true
    });

    return (
        <ContentWrapper className={className}>
          {title && (
                <Block className="mb-12">
                    <Column column="w-full">
                        <h2 className="text-6xl  font-header text-sky  text-concord-dark-green">
                            {title}
                        </h2>
                    </Column>
                </Block>
            )}
            <Block className="mt-5" >
                <Column className="cms-content">
                   <Block className="flex-wrap" fullHeight={false} flexOnMobile={true}>
                   {distributor.length && 
                        distributor.map(el => (
                            <Column key={el.originalId} column="sm:w-full  md:w-column" className="cms-content  cms-content--no-paragraph-margins  mb-5">
                                <div className="text-2xl  text-cobalt  font-normal  block">{el.region}</div>
                                <div className="font-bold">{el.name}</div>
                                
                                <div dangerouslySetInnerHTML={markdown(el.address)} />
                                <div>
                                   {el.phoneNumber && 
                                        <a href={`tel:${el.phoneNumber}`}>{el.phoneNumber}<br/></a>
                                    || null}
                                   {el.eMail && 
                                        <a href={`mailto:${el.eMail}`}>{el.eMail}<br/></a>
                                    || null}
                                   {el.website && 
                                        <a target="_blank" rel="noopener noreferrer" href={`${el.website}`}>{stripScheme(el.website)}<br/></a>
                                    || null}
                                </div>
                            </Column>
                        ))
                    || null}
                   </Block>
                </Column>

                <Column>
                    <Img fluid={map.fluid} />
                </Column>
            </Block>
        </ContentWrapper>
    );
}

DistributionLocation.propTypes = propTypes;
DistributionLocation.defaultProps = defaultProps;
